import { Box, Button, Grid } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import TradingViewWidget from 'react-tradingview-widget';
import { CustomChart } from '../../../frontend/components';
import { vdrData20YearsQuarterlyAction } from '../../../redux/actions/VdrAction';


const Charts = (props) => {
    const { technicalData } = props;
    const myRef = useRef();

    useEffect(() => {


        const script = document.createElement('script');
        script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js'
        script.async = true;
        var ab = {
            "interval": "1D",
            "width": "100%",
            "isTransparent": false,
            "height": 450,
            "symbol": technicalData?.companySymbolGauge,
            "showIntervalTabs": true,
            "locale": "en",
            "colorTheme": "light"
        };
        script.innerHTML = JSON.stringify(ab);
        myRef.current.appendChild(script);
    }, [])


    return (
        <>




            <Grid container spacing={2}>
                <Grid item xs={12} sm={9}>
                    <TradingViewWidget
                        symbol={technicalData?.companySymbolChart}
                        locale="en"
                        width="100%"
                        height="450"
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <div className="tradingview-widget-container" ref={myRef}>
                        <div className="tradingview-widget-container__widget"></div>
                    </div>
                </Grid>
            </Grid>

        </>
    )
}

export default Charts